<template>
<div class="chapter">
<div class="inner_page">
<p class="half"><a id="page_1"><i>The Spirits of Crossbones Graveyard</i></a></p><a id="page_1">
<p class="pub"><img alt="Image" src="images/pub.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_Fm03.vue?04bd6f6f